<template>
    <div class="tree-data-grid">
        <data-grid-aside
            :loading="loading"
            :props="props"
            ref="tree"
            :node-key="nodeKey"
            :action-sheet="actionSheet"
            :data="tree"
             @command="onCommand"
            @current-change="onCurrentNodeChange"/>
        <div class="data-grid-wrap">
            <Card v-if="$slots.headerbar" class="custom-headerbar" ref="headerbar" :bordered="false">
                <slot name="headerbar"/>
            </Card>
            <data-grid :model="model"
                ref="dataGrid"
                :auto-search="false"
                :api="api"
                :params="params"
                :diff-height="headerbarHeight"
                :items="items"
                v-model="model">
                <slot/>
                <template slot="operator">
                    <slot name="operator"/>
                </template>
                <template slot="dialog">
                    <slot name="dialog"/>
                </template>
                <template slot="alert">
                    <slot name="alert"/>
                </template>
            </data-grid>
        </div>
    </div>
</template>

<script>
import DataGridAside from './aside'
import DataGrid from './data-grid'
import { addResizeListener, removeResizeListener } from '@/libs/resize-observer'
export default {
  name: 'tree-data-grid',
  components: {
    DataGridAside,
    DataGrid
  },
  props: {
    treeApi: {
      type: String,
      default: ''
    },
    api: {
      type: String,
      default: ''
    },
    props: {
      type: Object,
      default () {
        return {
          label: 'label',
          children: 'children',
          disabled: 'disabled',
          isLeaf: 'isLeaf'
        }
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    },
    treeParams: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    actionSheet: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      tree: [],
      model: {},
      current: null,
      headerbarHeight: 0 // 用户自定义头部栏高度
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val !== oldVal) this.model = val
      }
    },
    model: {
      deep: true,
      handler (val, oldVal) {
        if (val !== oldVal) this.$emit('input', val)
      }
    }
  },
  methods: {
    onCommand (action, node) {
      this.$emit('command', action, node)
    },
    onHeaderbarResize () {
      // 10 外边距
      this.headerbarHeight = this.$refs.headerbar.$el.offsetHeight + 10
    },
    selectTree (id = '') {
      if (!this.treeApi) return
      this.loading = true
      this.$api(this.treeApi, this.treeParams).then(res => {
        if (res) {
          this.tree = res
          // 选取第一个叶子节点
          let currentId = ''
          if (!this.current && !id) {
            let leaf = this.getLeaf(res)
            currentId = leaf ? leaf[this.nodeKey] : ''
          } else if (id) {
            currentId = id
          } else {
            currentId = this.current.data[this.nodeKey]
          }
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(currentId)
            // TODO 改变current
          })
        }
        this.loading = false
      })
    },
    /**
         * @description 获取叶子节点 TODO 适配别名
         * @author yangyu
         */
    getLeaf (values, id) {
      if (!values) return null
      for (let i = 0; i < values.length; ++i) {
        let val = values[i]
        if (val.children && val.children.length) {
          let leaf = this.getLeaf(val.children, id)
          if (leaf) return leaf
        } else {
          if (id !== undefined && val.id == id) {
            return val
          } else if (id === undefined || id === null) return val
        }
      }
      return null
    },
    /**
         * @description 当前节点改变事件
         */
    onCurrentNodeChange (node) {
      this.current = node
      this.$emit('current-node-change', node)
      this.$nextTick(() => {
        this.select(true)
      })
    },
    /**
         * @description 数据表格
         */
    select (reload) {
      this.$refs.dataGrid.select(reload)
    }
  },
  mounted () {
    this.selectTree()
    this.$nextTick(() => {
      if (this.$refs.headerbar) addResizeListener(this.$refs.headerbar.$el, this.onHeaderbarResize)
    })
  },
  beforeDestroy () {
    if (this.$refs.headerbar) removeResizeListener(this.$refs.headerbar.$el, this.onHeaderbarResize)
  }
}
</script>

<style lang="less">
.tree-data-grid {
    display: flex;
    height: 100%;
    width: 100%;
    .data-grid-wrap {
        margin-left: 10px;
        // 320 侧栏 + 10
        flex: 0 0 calc(100% - 330px);
        width: calc(100% - 330px);
        .custom-headerbar {
            margin-bottom: 10px; // 重要点
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/tree-data-grid.vue